export default __webpack_public_path__ + "static/media/who-we-are-image-5.cfee9698.jpg";